import React from 'react';

import { SVGIcon } from '../../UIKit/index';

export default function DCFileStorage(props) {
    return (
        <SVGIcon {...props} viewBox="0 0 503.155 492.55">
            <g id="File_Storage" transform="translate(-4.815 -9.6)">
                <ellipse
                    id="_Path_"
                    data-name="&lt;Path&gt;"
                    cx="235.61"
                    cy="33.6"
                    rx="235.61"
                    ry="33.6"
                    transform="translate(36.75 434.95)"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_1"
                    data-name="Path 1"
                    d="M303.36,84.18l12.53-53.29c.05-2.35,1.66-5.66,3.72-6.6a5,5,0,0,1,3.28-.33l29.84,7.59a4.82,4.82,0,0,1,3.63,3.84l1.6,8.06,39,10c5.3.88,7.5,5.79,6.16,9.47l-11.89,44.94c-1.9,5.19-7.57,8-12.1,6.86l-69-17.55C305.44,95.93,302.5,90.74,303.36,84.18Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_2"
                    data-name="Path 2"
                    d="M302.5,83.12l11-44.57c1.29-3.41,4.28-5.42,7-4.73l78.22,19.9c3.32.85,4.93,5.25,3.45,9.42l-9.88,41.29c-2.62,10.27-8.86,11.95-13.53,10.76L310.2,97.75C303.15,96,299.9,91.86,302.5,83.12Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_3"
                    data-name="Path 3"
                    d="M354.53,87.75a12.56,12.56,0,0,1-3.75-.57,12.781,12.781,0,1,1,15.98-8.44h0a12.81,12.81,0,0,1-12.23,9.01Zm0-24.48A11.69,11.69,0,1,0,365.7,78.39h0a11.7,11.7,0,0,0-11.17-15.12Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_4"
                    data-name="Path 4"
                    d="M351.66,74.08l1.62-5.27,3.75,4.03,3.76,4.04-5.38,1.23-5.37,1.24Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_5"
                    data-name="Path 5"
                    d="M120.38,362.27,61.55,394.06a8.36,8.36,0,0,1-11.34-3.38l-44-81.43a8.36,8.36,0,0,1,3.38-11.34L46.9,277.75l45,14.15,31.9,59a8.37,8.37,0,0,1-3.42,11.37Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_6"
                    data-name="Path 6"
                    d="M84.43,331.11a8.883,8.883,0,0,0,1.28-1,7.88,7.88,0,0,0,2.36-3.8,7.59,7.59,0,0,0,.16-3.22,7.049,7.049,0,0,0-.52-1.78c-.26-.58-.6-1.18-.94-1.8l-4.63-8.46c-.86-1.56-1.75-3.21-2.69-4.92L78,303.56A13.49,13.49,0,0,0,76.4,301a8.58,8.58,0,0,0-8.68-2.64,13.659,13.659,0,0,0-3.11,1.41l-27,14.65A8.24,8.24,0,0,0,34,320.94a7.89,7.89,0,0,0,.72,3.69c.54,1.13,1.21,2.28,1.8,3.41l7,13c.57,1,1.09,2.12,1.68,3a7.78,7.78,0,0,0,8.4,3.07,12.81,12.81,0,0,0,2.75-1.25l2.63-1.4L64,341.88l14.93-7.94L83,331.81l1.07-.54a1.677,1.677,0,0,1,.37-.16,1.4,1.4,0,0,1-.34.22l-1,.6-4,2.25-14.82,8.14L59.3,345l-2.62,1.42a13,13,0,0,1-2.87,1.31,8.36,8.36,0,0,1-9.07-3.27c-.67-1-1.14-2-1.73-3.08l-7.07-13c-.6-1.15-1.24-2.23-1.83-3.46a8.51,8.51,0,0,1-.78-4,8.93,8.93,0,0,1,3.93-7.08c9.6-5.29,18.72-10.14,27-14.63a14.882,14.882,0,0,1,3.25-1.46,9.18,9.18,0,0,1,9.29,2.88,13.589,13.589,0,0,1,1.68,2.66l1.41,2.63,2.65,4.94,4.53,8.5c.34.63.67,1.22.94,1.85a7.71,7.71,0,0,1,.51,1.86,7.84,7.84,0,0,1-.23,3.36,7.72,7.72,0,0,1-2.53,3.83,6,6,0,0,1-1.33.85Z"
                    fill="#707272"
                />
                <path
                    id="Path_7"
                    data-name="Path 7"
                    d="M89,323.69a2.75,2.75,0,0,1-.66-.21l-1.85-.74-6.74-2.81-4.65-2-2.58-1.1-1.34-.57a2.34,2.34,0,0,0-1.31-.11A2.37,2.37,0,0,0,68,318q-.26,1.58-.54,3.21c-.37,2.19-.75,4.46-1.14,6.78-.17,1-.35,2.07-.51,3l-.07.39-.37-.11-6.1-1.72-1.46-.41a3.73,3.73,0,0,0-1.34-.24,2.55,2.55,0,0,0-2.07,1.28,5.231,5.231,0,0,0-.43,1.23l-.36,1.29c-.24.84-.48,1.66-.7,2.46l-1.26,4.4c-.76,2.6-1.38,4.72-1.85,6.31-.21.68-.39,1.24-.53,1.7a2.4,2.4,0,0,1-.23.58,2.19,2.19,0,0,1,.1-.62c.11-.47.24-1,.41-1.73.41-1.6,1-3.75,1.64-6.37.36-1.36.76-2.84,1.18-4.42.21-.8.43-1.62.66-2.47.11-.43.23-.86.35-1.29a5.64,5.64,0,0,1,.47-1.38,3.17,3.17,0,0,1,2.58-1.62,4.12,4.12,0,0,1,1.56.25l1.46.4,6.11,1.7-.45.28c.17-1,.34-2,.52-3,.39-2.32.78-4.58,1.15-6.77.19-1.1.38-2.18.56-3.23a3,3,0,0,1,4-2.19l1.36.6,2.57,1.14,4.61,2.05,6.65,3,1.8.86A2.681,2.681,0,0,1,89,323.69Z"
                    fill="#707272"
                />
                <path
                    id="Path_8"
                    data-name="Path 8"
                    d="M57.42,320.2c0-.05.3-.25.78-.72A4.4,4.4,0,0,0,59.4,317a4.1,4.1,0,0,0-1.4-3.63A4,4,0,0,0,51.37,317a4.12,4.12,0,0,0,2.29,3.15,4.35,4.35,0,0,0,2.73.34q.493-.15,1-.25a2.644,2.644,0,0,1-1,.52,4.32,4.32,0,0,1-3-.16,4.55,4.55,0,0,1-2.73-3.5,4.66,4.66,0,0,1,7.73-4.18,4.59,4.59,0,0,1,1.43,4.2,4.35,4.35,0,0,1-1.51,2.6,2.05,2.05,0,0,1-.89.48Z"
                    fill="#707272"
                />
                <path
                    id="Path_9"
                    data-name="Path 9"
                    d="M41.28,347h83.61v26.8a6.36,6.36,0,0,1-6.36,6.36H47.63a6.36,6.36,0,0,1-6.36-6.36V347Z"
                    transform="matrix(0.88, -0.475, 0.475, 0.88, -162.89, 83.24)"
                    fill="#707272"
                />
                <path
                    id="Path_10"
                    data-name="Path 10"
                    d="M46.89,277.75l12.38,22.91a7.78,7.78,0,0,0,10.55,3.15l22-11.91Z"
                    fill="#ebebeb"
                />
                <path
                    id="Path_11"
                    data-name="Path 11"
                    d="M60.66,302.51s2.72,5.72,10,4.13c.28-.06.55-.15.82-.23,3.15-1,23.91-7.91,23.68-8.35s-3.33-6.16-3.33-6.16l-22,11.91S64.22,306.6,60.66,302.51Z"
                    fill="#e0e0e0"
                />
                <path
                    id="Path_12"
                    data-name="Path 12"
                    d="M75.93,366.09l2.42-1.31,2.5,4.64a9,9,0,0,1-3.83,4c-3.6,1.94-7.58.9-9.44-2.54s-.55-7.35,3.09-9.32a6.93,6.93,0,0,1,5.86-.61l-.85,2.49a4.4,4.4,0,0,0-3.66.3A4.16,4.16,0,1,0,75.94,371a4.84,4.84,0,0,0,1.8-1.6Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_13"
                    data-name="Path 13"
                    d="M77.8,357.92l2.64-1.43,6.19,11.44L84,369.36Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_14"
                    data-name="Path 14"
                    d="M87,355.72l1.63,3,5.3-2.86L95,358l-5.3,2.87L92,365l-2.64,1.43L83.15,355l8.65-4.67,1.2,2.15Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_15"
                    data-name="Path 15"
                    d="M403.25,419.48,361.67,399.4a5.78,5.78,0,0,1-2.68-7.72l27.8-57.54a5.77,5.77,0,0,1,7.71-2.69l26.37,12.74,10.24,30.89L411,416.79a5.77,5.77,0,0,1-7.75,2.69Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_16"
                    data-name="Path 16"
                    d="M406.16,386.77a8.658,8.658,0,0,0,1.06.33,5.41,5.41,0,0,0,3.08-.22,5.2,5.2,0,0,0,2.65-2.22c.22-.38.42-.81.63-1.26l2.86-6,1.67-3.5.89-1.85a9.453,9.453,0,0,0,.77-1.94,5.92,5.92,0,0,0-.59-4.2,5.84,5.84,0,0,0-1.44-1.73,9.687,9.687,0,0,0-2.05-1.17l-19.09-9.17a5.7,5.7,0,0,0-5.11.6,5.419,5.419,0,0,0-1.77,1.89c-.42.76-.79,1.61-1.18,2.39l-4.47,9.21c-.34.73-.74,1.46-1,2.16a5.28,5.28,0,0,0-.29,2.22,5.35,5.35,0,0,0,2,3.72,8.773,8.773,0,0,0,1.81,1l1.85.9,3.48,1.7,10.48,5.15,2.84,1.42.73.38q.25.13.24.15l-.26-.1-.75-.34L402.27,385l-10.55-5-3.49-1.67-1.86-.89a9.2,9.2,0,0,1-1.89-1.07,5.79,5.79,0,0,1-2.14-4,5.69,5.69,0,0,1,.31-2.41c.29-.78.68-1.46,1-2.21,1.41-2.94,2.9-6,4.44-9.21.39-.81.74-1.6,1.19-2.43a5.89,5.89,0,0,1,1.92-2,6.19,6.19,0,0,1,5.55-.66c6.84,3.24,13.24,6.39,19.12,9.23a10.332,10.332,0,0,1,2.13,1.23,6.38,6.38,0,0,1,1.54,1.86,6.31,6.31,0,0,1,.6,4.5,9.8,9.8,0,0,1-.81,2c-.31.63-.61,1.24-.9,1.85l-1.7,3.48q-1.62,3.315-2.93,6c-.21.44-.41.87-.65,1.27a5.457,5.457,0,0,1-.84,1,5.38,5.38,0,0,1-5.14,1.36,4.511,4.511,0,0,1-1.01-.46Z"
                    fill="#707272"
                />
                <path
                    id="Path_17"
                    data-name="Path 17"
                    d="M412.14,386.3a2.942,2.942,0,0,1-.15-.46c-.09-.35-.2-.79-.33-1.33-.29-1.23-.68-2.89-1.15-4.91-.24-1.05-.5-2.18-.77-3.4l-.43-1.89c-.07-.32-.14-.65-.22-1a1.579,1.579,0,0,0-.47-.78,1.62,1.62,0,0,0-1.76-.28l-2,1-4.25,2.1-1.91.94-.24.12-.09-.25c-.52-1.41-1-2.79-1.5-4.11l-.36-1a2.49,2.49,0,0,0-.41-.85,1.75,1.75,0,0,0-1.55-.64,3.759,3.759,0,0,0-.86.25l-.87.32-1.66.6-3,1.08-4.28,1.51-1.17.39c-.27.08-.41.12-.42.1a2,2,0,0,1,.39-.19l1.13-.47,4.24-1.65,2.95-1.1,1.65-.63.87-.33a4,4,0,0,1,1-.29,2.19,2.19,0,0,1,1.95.79,3,3,0,0,1,.49,1c.12.32.24.65.37,1,.49,1.32,1,2.69,1.51,4.1l-.33-.13,1.9-.94,4.26-2.09,2-1a2.1,2.1,0,0,1,2.26.38,2.14,2.14,0,0,1,.59,1l.21,1c.14.65.27,1.28.4,1.9.26,1.22.5,2.36.72,3.41.41,2,.74,3.7,1,4.94.1.54.18,1,.25,1.35A1.58,1.58,0,0,1,412.14,386.3Z"
                    fill="#707272"
                />
                <path
                    id="Path_18"
                    data-name="Path 18"
                    d="M401.35,367.24a5.8,5.8,0,0,1,.73.14,3,3,0,0,0,1.86-.33,2.85,2.85,0,0,0,1.49-2.23,2.8,2.8,0,0,0-4.71-2.28,2.86,2.86,0,0,0-.83,2.56,2.94,2.94,0,0,0,.91,1.66c.34.32.57.44.55.48a1.459,1.459,0,0,1-.68-.33,3.06,3.06,0,0,1-1.12-1.75,3.15,3.15,0,0,1,.86-2.94,3.22,3.22,0,0,1,5.46,2.64,3.16,3.16,0,0,1-1.77,2.5,3,3,0,0,1-2.06.21,1.479,1.479,0,0,1-.69-.33Z"
                    fill="#707272"
                />
                <path
                    id="Path_19"
                    data-name="Path 19"
                    d="M358.58,387.68H416.3v16.54a6.36,6.36,0,0,1-6.36,6.36h-45a6.36,6.36,0,0,1-6.36-6.36V387.68Z"
                    transform="translate(212.22 -128.8) rotate(25.79)"
                    fill="#707272"
                />
                <path
                    id="Path_20"
                    data-name="Path 20"
                    d="M420.87,344.19,413,360.38a5.38,5.38,0,0,0,2.5,7.18l15.57,7.52Z"
                    fill="#ebebeb"
                />
                <path
                    id="Path_21"
                    data-name="Path 21"
                    d="M412.57,361.91s-2.1,3.83,1.74,7.28a5.189,5.189,0,0,0,.46.36c1.86,1.35,14.09,10.19,14.24,9.89l2.1-4.36-15.57-7.52S411.72,365.55,412.57,361.91Z"
                    fill="#e0e0e0"
                />
                <path
                    id="Path_22"
                    data-name="Path 22"
                    d="M383.14,396.14l1.71.83-1.58,3.28a6.21,6.21,0,0,1-3.77-.56,4.65,4.65,0,1,1,4.08-8.34,4.81,4.81,0,0,1,2.71,3l-1.74.53A3,3,0,0,0,382.9,393a2.871,2.871,0,0,0-2.52,5.16,3.3,3.3,0,0,0,1.62.36Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_23"
                    data-name="Path 23"
                    d="M388.47,393.89l1.87.9-3.9,8.08-1.87-.9Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_24"
                    data-name="Path 24"
                    d="M393.4,398.12l-1,2.14,3.74,1.8-.72,1.51-3.74-1.81-1.43,2.94-1.87-.9,3.91-8.09,6.11,3-.73,1.5Z"
                    fill="#f4f5f6"
                />
                <rect
                    id="Rectangle_1"
                    data-name="Rectangle 1"
                    width="94.67"
                    height="75.68"
                    transform="translate(21.122 95.843) rotate(-12.94)"
                    fill="#fafbfb"
                />
                <path
                    id="Path_25"
                    data-name="Path 25"
                    d="M113.39,74.64l-.45.12-1.29.31-5,1.18L87.77,80.66,21.18,96.08l.18-.29c5.05,21.95,10.85,47.12,17,73.75h0l-.33-.2,92.27-21.15-.17.27L117.94,94.93c-1.46-6.44-2.6-11.5-3.38-15-.39-1.72-.68-3-.88-4s-.29-1.38-.29-1.38.12.44.33,1.32l.92,3.9c.8,3.44,2,8.47,3.48,14.88,3,12.91,7.27,31.36,12.44,53.62l.05.22h-.22L38.13,169.87l-.27.06-.06-.26h0C31.69,143,25.92,117.85,20.88,95.9l-.05-.24.24-.06,66.8-15.22,18.85-4.26,5-1.12,1.27-.27Z"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_2"
                    data-name="Rectangle 2"
                    width="87.548"
                    height="65.805"
                    transform="translate(24.873 99.463) rotate(-12.779)"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_26"
                    data-name="Path 26"
                    d="M40.18,164.23l20.76-46.96,24.32,20.81,9.51-16.3,31.2,22.74Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_27"
                    data-name="Path 27"
                    d="M86.25,106.29a6.93,6.93,0,1,1-3.075-4.328A6.93,6.93,0,0,1,86.25,106.29Z"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_3"
                    data-name="Rectangle 3"
                    width="143.05"
                    height="114.36"
                    transform="matrix(0.999, -0.042, 0.042, 0.999, 68.271, 15.588)"
                    fill="#fafbfb"
                />
                <path
                    id="Path_28"
                    data-name="Path 28"
                    d="M211.2,9.64h-.69l-2,.1-7.76.37-29.26,1.32L68.29,16l.35-.39c1.43,34,3.07,73,4.8,114.25h0l-.43-.39,142.93-5.88-.33.36C214.25,89.51,213.12,61,212.34,41c-.38-10-.67-17.81-.88-23.17q-.14-4-.21-6.11c-.05-1.39-.05-2.12-.05-2.12s.05.68.12,2,.17,3.42.29,6.05c.24,5.34.6,13.14,1,23.08.88,20,2.13,48.59,3.64,83.08v.34h-.35L73,130.26h-.41v-.41h0C70.91,88.6,69.3,49.61,67.9,15.6v-.37h.37L171.71,11.1,200.89,10l7.69-.27,2-.06A4.846,4.846,0,0,1,211.2,9.64Z"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_4"
                    data-name="Rectangle 4"
                    width="133"
                    height="99.96"
                    transform="matrix(0.999, -0.042, 0.042, 0.999, 73.496, 22.577)"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_29"
                    data-name="Path 29"
                    d="M77.65,122.45l43.83-64.01,30.37,37.64,18.64-21.57,40.05,42.41Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_30"
                    data-name="Path 30"
                    d="M162.12,49.13a10.47,10.47,0,1,1-10.9-10A10.47,10.47,0,0,1,162.12,49.13Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_31"
                    data-name="Path 31"
                    d="M177.25,199.3l-22.43-63.41c-1.52-2.46-2-6.95-.54-9.3a6.08,6.08,0,0,1,3.17-2.52l35.89-12a5.9,5.9,0,0,1,6.3,1.55l7,7.27,47-15.61c6.07-2.62,11.6,1,12.66,5.69l17.55,54.36c1.49,6.62-2.51,13.31-7.95,15.13l-83,27.66C187.2,210.06,180.72,206.65,177.25,199.3Z"
                    fill="#f3725f"
                />
                <path
                    id="Path_32"
                    data-name="Path 32"
                    d="M177.25,199.3l-22.43-63.41c-1.52-2.46-2-6.95-.54-9.3a6.08,6.08,0,0,1,3.17-2.52l35.89-12a5.9,5.9,0,0,1,6.3,1.55l7,7.27,47-15.61c6.07-2.62,11.6,1,12.66,5.69l17.55,54.36c1.49,6.62-2.51,13.31-7.95,15.13l-83,27.66C187.2,210.06,180.72,206.65,177.25,199.3Z"
                    fill="#707272"
                />
                <path
                    id="Path_33"
                    data-name="Path 33"
                    d="M176,198.67l-18.26-53.36c-.93-4.39.82-8.45,4.12-9.55l94.08-31.38c4-1.32,8.58,2.16,9.82,7.45L283,161.08c4.12,12.35-1.22,18.23-6.84,20.1l-82.45,27.5C185.2,211.5,179.12,209.43,176,198.67Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_34"
                    data-name="Path 34"
                    d="M244.26,167.88a8.094,8.094,0,0,0,1.2-.61,6.66,6.66,0,0,0,2.52-2.82,6.43,6.43,0,0,0,.6-2.66,6.11,6.11,0,0,0-.17-1.56c-.13-.52-.33-1.07-.52-1.63-.78-2.28-1.65-4.87-2.62-7.72q-.72-2.15-1.52-4.49c-.26-.78-.53-1.57-.8-2.39a11.35,11.35,0,0,0-1-2.35,7.23,7.23,0,0,0-6.84-3.47,11.71,11.71,0,0,0-2.79.72l-24.59,8.26a7,7,0,0,0-4,4.9,6.79,6.79,0,0,0,.06,3.17c.29,1,.68,2.08,1,3.1,1.37,4.12,2.69,8.1,3.94,11.89.33.93.6,1.92,1,2.76a6.57,6.57,0,0,0,6.54,3.79,10.911,10.911,0,0,0,2.48-.64l2.39-.79,4.5-1.48,13.6-4.43,3.7-1.18,1-.29a1.58,1.58,0,0,1,.34-.08,1.581,1.581,0,0,1-.32.14l-.95.35-3.67,1.28-13.53,4.61-4.49,1.52-2.39.81a11.481,11.481,0,0,1-2.58.67,7.054,7.054,0,0,1-7.08-4.05c-.41-1-.65-1.86-1-2.82l-4-11.87c-.33-1-.71-2-1-3.15a7.27,7.27,0,0,1-.07-3.44,7.61,7.61,0,0,1,4.31-5.32c8.77-3,17.07-5.7,24.65-8.23a12.64,12.64,0,0,1,2.92-.74A7.81,7.81,0,0,1,238,138a7.66,7.66,0,0,1,4.38,3.43,11.931,11.931,0,0,1,1,2.46l.79,2.4c.51,1.56,1,3.06,1.48,4.5.94,2.86,1.79,5.46,2.53,7.74.19.57.38,1.11.52,1.67a7.149,7.149,0,0,1,.15,1.64,6.59,6.59,0,0,1-3.35,5.58A4.721,4.721,0,0,1,244.26,167.88Z"
                    fill="#707272"
                />
                <path
                    id="Path_35"
                    data-name="Path 35"
                    d="M249.1,162.36a1.83,1.83,0,0,1-.52-.27l-1.43-.88-5.2-3.33-3.58-2.32-2-1.3-1-.67a1.89,1.89,0,0,0-1.07-.28,2,2,0,0,0-1.79,1.26c-.3.85-.6,1.71-.92,2.59q-.93,2.66-1.94,5.48c-.29.84-.59,1.67-.87,2.45l-.11.31-.3-.14-4.82-2.33-1.15-.55a3.23,3.23,0,0,0-1.09-.4,2.15,2.15,0,0,0-1.91.77,3.8,3.8,0,0,0-.53,1l-.5,1-.94,1.94c-.6,1.25-1.17,2.41-1.68,3.48-1,2-1.85,3.74-2.47,5-.28.53-.5,1-.69,1.34s-.26.45-.28.44a3.238,3.238,0,0,1,.18-.49l.59-1.39,2.3-5.06L217,166.5c.3-.63.6-1.29.92-2,.15-.34.31-.68.47-1a5.289,5.289,0,0,1,.6-1.07,2.68,2.68,0,0,1,2.39-1,3.84,3.84,0,0,1,1.26.44l1.16.55,4.83,2.3-.41.17.87-2.45L231,157c.32-.89.64-1.76.94-2.61a2.55,2.55,0,0,1,2.31-1.6,2.46,2.46,0,0,1,1.36.37l1,.69,2,1.33,3.54,2.38,5.1,3.49,1.37,1C249,162.22,249.12,162.35,249.1,162.36Z"
                    fill="#707272"
                />
                <path
                    id="Path_36"
                    data-name="Path 36"
                    d="M223.36,154.85a8.423,8.423,0,0,0,.75-.49,3.68,3.68,0,0,0,1.36-1.88,3.48,3.48,0,0,0-.61-3.23,3.42,3.42,0,0,0-6.07,2,3.51,3.51,0,0,0,1.45,2.95,3.62,3.62,0,0,0,2.22.68c.57,0,.88-.11.9-.06a1.62,1.62,0,0,1-.88.3,3.73,3.73,0,0,1-2.48-.57,3.89,3.89,0,0,1-1.76-3.32,3.94,3.94,0,0,1,7-2.35,3.87,3.87,0,0,1,.58,3.71,3.6,3.6,0,0,1-1.64,1.94C223.7,154.85,223.36,154.88,223.36,154.85Z"
                    fill="#707272"
                />
                <path
                    id="Path_37"
                    data-name="Path 37"
                    d="M93.6,428.08l-41.15-174c-1.72-7.29.6-15.13,6.29-19.66a15.9,15.9,0,0,1,9.95-3.58l113.92-3.6a15.47,15.47,0,0,1,14.35,9l11.36,23.57,144.68.14c10.63,0,21.79,14.75,20.52,27.12l12.35,145c-1.79,17.48-17.22,30.63-32.22,30.63H125.08C109.38,462.65,96.11,449,93.6,428.08Z"
                    fill="#707272"
                />
                <g id="Group_1" data-name="Group 1" opacity="0.3">
                    <path
                        id="Path_38"
                        data-name="Path 38"
                        d="M93.6,428.08l-41.15-174c-1.72-7.29.6-15.13,6.29-19.66a15.9,15.9,0,0,1,9.95-3.58l113.92-3.6a15.47,15.47,0,0,1,14.35,9l11.36,23.57,144.68.14c10.63,0,21.79,14.75,20.52,27.12l12.35,145c-1.79,17.48-17.22,30.63-32.22,30.63H125.08C109.38,462.65,96.11,449,93.6,428.08Z"
                    />
                </g>
                <path
                    id="Path_39"
                    data-name="Path 39"
                    d="M95.57,433.15,84.68,240.4l269.85-4.09,9.46,193.18Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_40"
                    data-name="Path 40"
                    d="M94.34,248.3a1.81,1.81,0,1,1-1.8-2,1.89,1.89,0,0,1,1.8,2Z"
                    fill="#707272"
                />
                <path
                    id="Path_41"
                    data-name="Path 41"
                    d="M101.34,248.3a1.81,1.81,0,1,1-1.8-2,1.89,1.89,0,0,1,1.8,2Z"
                    fill="#707272"
                />
                <path
                    id="Path_42"
                    data-name="Path 42"
                    d="M108.35,248.3a1.81,1.81,0,1,1-1.81-2,1.89,1.89,0,0,1,1.81,2Z"
                    fill="#707272"
                />
                <path
                    id="Path_43"
                    data-name="Path 43"
                    d="M191.07,248.3l16.27,96.73L79.28,364.27,63,267.53Z"
                    fill="#ebebeb"
                />
                <path
                    id="Path_44"
                    data-name="Path 44"
                    d="M191.07,248.3l-.62.11-1.79.29-7,1.08-26.2,4L63.05,267.85l.28-.37c4.86,28.8,10.42,61.8,16.31,96.72h0l-.43-.3L207.3,344.74l-.26.34c-4.84-29.14-8.85-53.29-11.65-70.18-1.39-8.45-2.47-15.08-3.22-19.62-.36-2.26-.64-4-.83-5.18s-.27-1.8-.27-1.8.12.57.32,1.72.51,2.89.9,5.12l3.37,19.53c2.88,16.92,7,41.12,12,70.32v.29l-.31.05L79.33,364.62l-.37.06-.06-.35h0c-5.9-34.94-11.4-67.95-16.23-96.75l-.06-.31h.33l92.72-13.77,26.16-3.84,6.9-1,1.76-.24A3.17,3.17,0,0,1,191.07,248.3Z"
                    fill="#515251"
                />
                <path
                    id="Path_45"
                    data-name="Path 45"
                    d="M82.67,357.52l119.07-17.89-14.23-84.56L68.44,272.96Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_46"
                    data-name="Path 46"
                    d="M82.67,357.52l32.74-58.81,31.3,29.02,14.51-20.21,40.52,32.11Z"
                    fill="#707272"
                />
                <path
                    id="Path_47"
                    data-name="Path 47"
                    d="M151,286.76A9,9,0,0,1,143.14,297a9.45,9.45,0,0,1-10.87-7.45,9.05,9.05,0,0,1,7.89-10.27A9.43,9.43,0,0,1,151,286.76Z"
                    fill="#707272"
                />
                <path
                    id="Path_48"
                    data-name="Path 48"
                    d="M103.36,442.29,99.71,254.74l276-.58L374.57,439.5Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_49"
                    data-name="Path 49"
                    d="M115.71,262.09a1.81,1.81,0,1,1-1.81-1.95,1.89,1.89,0,0,1,1.81,1.95Z"
                    fill="#707272"
                />
                <path
                    id="Path_50"
                    data-name="Path 50"
                    d="M122.18,262.09a1.81,1.81,0,1,1-1.81-1.95,1.89,1.89,0,0,1,1.81,1.95Z"
                    fill="#707272"
                />
                <path
                    id="Path_51"
                    data-name="Path 51"
                    d="M108.84,262.09a1.81,1.81,0,1,1-1.8-1.95,1.89,1.89,0,0,1,1.8,1.95Z"
                    fill="#707272"
                />
                <path
                    id="Path_52"
                    data-name="Path 52"
                    d="M109.77,446.86V268.54l274.86-.57L369.87,450.7Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_53"
                    data-name="Path 53"
                    d="M96.39,427.12l16.44-134c1.29-10.48,8.75-18.24,17.54-18.24H381.42c10.62,0,18.86,11.19,17.59,23.9l-13.14,132.4c-3.85,27.53-14.42,31.47-29.43,31.47H121.83C106.13,462.65,90.94,458.71,96.39,427.12Z"
                    fill="#707272"
                />
                <path
                    id="Path_54"
                    data-name="Path 54"
                    d="M263.79,345.68,271,360.32a4,4,0,0,0,3,2.2l16.16,2.35a4,4,0,0,1,2.23,6.86l-11.69,11.4a4,4,0,0,0-1.16,3.56l2.76,16.09a4,4,0,0,1-5.8,4.22l-14.45-7.6a4,4,0,0,0-3.75,0L243.85,407a4,4,0,0,1-5.84-4.25l2.76-16.09a4,4,0,0,0-1.16-3.56l-11.69-11.4a4,4,0,0,1,2.23-6.86l16.16-2.35a4,4,0,0,0,3-2.2l7.23-14.64a4,4,0,0,1,7.25.03Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_55"
                    data-name="Path 55"
                    d="M435.87,423.81c.14,1.05,2.72,30.4,2.72,30.4H452l2.35-30.27Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_56"
                    data-name="Path 56"
                    d="M437.08,452.19v1.05s-18.1,6.68-18.39,10.07l35.54.84-.2-11.84a20.34,20.34,0,0,1-16.95-.12Z"
                    fill="#707272"
                />
                <g id="Group_2" data-name="Group 2" opacity="0.6">
                    <path
                        id="Path_57"
                        data-name="Path 57"
                        d="M450.3,456a1.44,1.44,0,0,1,1,1.68,1.39,1.39,0,0,1-1.65,1,1.54,1.54,0,0,1-1-1.79,1.46,1.46,0,0,1,1.84-.82"
                        fill="#fff"
                    />
                </g>
                <g id="Group_3" data-name="Group 3" opacity="0.6">
                    <path
                        id="Path_58"
                        data-name="Path 58"
                        d="M454.19,464.15l-.05-2.85-34,.24s-1.6.65-1.45,1.77Z"
                        fill="#515251"
                    />
                </g>
                <path
                    id="Path_59"
                    data-name="Path 59"
                    d="M436.91,453.34c0,.17.87.27,1.71.85s1.28,1.32,1.44,1.26-.07-1.08-1.1-1.76S436.88,453.18,436.91,453.34Z"
                    fill="#263238"
                />
                <path
                    id="Path_60"
                    data-name="Path 60"
                    d="M433.15,454.79c0,.17.7.48,1.27,1.23s.73,1.53.9,1.53.31-1-.42-1.9S433.16,454.63,433.15,454.79Z"
                    fill="#263238"
                />
                <path
                    id="Path_61"
                    data-name="Path 61"
                    d="M430.93,459.21c.15,0,.42-.83,0-1.79s-1.22-1.35-1.3-1.21.41.66.75,1.46S430.76,459.18,430.93,459.21Z"
                    fill="#263238"
                />
                <path
                    id="Path_62"
                    data-name="Path 62"
                    d="M447.7,429.42c.13,1.05,2.72,30.39,2.72,30.39h13.44l2.36-30.27Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_63"
                    data-name="Path 63"
                    d="M463.9,455.44s-9.44,6.7-14,.9l-1.2,2.81-5.36,20a2.67,2.67,0,0,0,1.51,3.21,2.57,2.57,0,0,0,2.74-.52c3.89-3.69,18.1-17.35,18-19.2l-.05-4.92a2.49,2.49,0,0,0-1.59-2.3Z"
                    fill="#707272"
                />
                <path
                    id="Path_64"
                    data-name="Path 64"
                    d="M445.3,482.52,465.55,461v1a3,3,0,0,1-1,2.37c-1.63,2.21-6.17,7.15-16.92,17.47a2.6,2.6,0,0,1-2.36.66Z"
                    fill="#515251"
                />
                <g id="Group_4" data-name="Group 4" opacity="0.6">
                    <path
                        id="Path_65"
                        data-name="Path 65"
                        d="M462.58,457.75a1.58,1.58,0,0,0-.44,2.05,1.51,1.51,0,0,0,2,.45,1.65,1.65,0,0,0,.46-2.17,1.57,1.57,0,0,0-2.17-.24"
                        fill="#fff"
                    />
                </g>
                <path
                    id="Path_66"
                    data-name="Path 66"
                    d="M451.14,471.47c-.15.07-.71-1.26-2.22-2a8.1,8.1,0,0,0-2.91-.57c0-.06.3-.26.89-.34a4.15,4.15,0,0,1,4,2C451.16,471.08,451.2,471.45,451.14,471.47Z"
                    fill="#263238"
                />
                <path
                    id="Path_67"
                    data-name="Path 67"
                    d="M449.32,474.86a20.874,20.874,0,0,0-2.24-1.1,21.811,21.811,0,0,0-2.48-.33,2.89,2.89,0,0,1,2.64-.2C448.73,473.67,449.45,474.79,449.32,474.86Z"
                    fill="#263238"
                />
                <path
                    id="Path_68"
                    data-name="Path 68"
                    d="M454.51,467.14a23.317,23.317,0,0,0-3.34-1.93,25.614,25.614,0,0,0-3.75-.9,5.77,5.77,0,0,1,4,.38,5.65,5.65,0,0,1,3.09,2.45Z"
                    fill="#263238"
                />
                <path
                    id="Path_69"
                    data-name="Path 69"
                    d="M455,461c-.06.15-1.46-.44-3.28-.51s-3.27.36-3.32.2a6.42,6.42,0,0,1,6.6.31Z"
                    fill="#263238"
                />
                <path
                    id="Path_70"
                    data-name="Path 70"
                    d="M450.64,460.47a2.16,2.16,0,0,1,.14-1A6.718,6.718,0,0,1,452,457.2a3,3,0,0,1,1.5-1.2,1,1,0,0,1,1.11.45,1.69,1.69,0,0,1,.18,1.2,3.66,3.66,0,0,1-3.78,2.74,4.24,4.24,0,0,1-3.7-2.95,1.5,1.5,0,0,1,.15-1.23,1,1,0,0,1,1.16-.33,3.64,3.64,0,0,1,1.48,1.16,7.65,7.65,0,0,1,1.34,2.25,2.35,2.35,0,0,1,.22.94,11.591,11.591,0,0,0-1.85-2.93,3.441,3.441,0,0,0-1.32-1,.56.56,0,0,0-.63.18,1,1,0,0,0-.06.81,3.8,3.8,0,0,0,3.24,2.53,3.19,3.19,0,0,0,3.25-2.29,1.23,1.23,0,0,0-.09-.84.57.57,0,0,0-.61-.25,2.65,2.65,0,0,0-1.3.95A9.941,9.941,0,0,0,450.64,460.47Z"
                    fill="#263238"
                />
                <path
                    id="Path_71"
                    data-name="Path 71"
                    d="M482.85,266.12l-66.06,13.41-.18,12.78a45.368,45.368,0,0,0,.35,6.27l7.92,62.49,11.53,86.78,11.1-.62.13,3.41,18.58-1.07s11.52-53.33,10.6-65.19c-1.88-24.32,2.1-36.52,5.12-49C485.2,322,497.16,290.1,482.85,266.12Z"
                    fill="#515251"
                />
                <g id="Group_5" data-name="Group 5" opacity="0.5">
                    <path
                        id="Path_72"
                        data-name="Path 72"
                        d="M440.64,293.78a1.645,1.645,0,0,0,0,.33c0,.24,0,.57,0,1,0,.88.07,2.14.13,3.74.13,3.28.33,8,.57,13.77.54,11.65,1.27,27.71,2.08,45.44s1.66,33.78,2.23,45.43c.3,5.8.55,10.49.72,13.77.1,1.6.17,2.86.23,3.74,0,.41.05.73.07,1a1.179,1.179,0,0,0,0,.34,2.987,2.987,0,0,0,0-.34v-1c0-.89-.07-2.14-.13-3.75-.14-3.28-.33-8-.58-13.77-.53-11.65-1.26-27.7-2.08-45.44s-1.65-33.77-2.22-45.42c-.3-5.8-.55-10.49-.73-13.77-.09-1.61-.17-2.86-.22-3.75,0-.4-.05-.73-.07-1a1.683,1.683,0,0,0,0-.32Z"
                    />
                </g>
                <path
                    id="Path_73"
                    data-name="Path 73"
                    d="M446.71,421.39a5.259,5.259,0,0,0-.07,1.15c0,.85,0,1.9,0,3.14,0,2.65.05,6.31.16,10.35s.28,7.7.45,10.34c.09,1.32.17,2.39.25,3.13a5.389,5.389,0,0,0,.16,1.14,5.726,5.726,0,0,0,0-1.15c0-.84-.05-1.89-.09-3.14-.08-2.75-.19-6.35-.31-10.34s-.22-7.58-.3-10.34c-.06-1.24-.1-2.29-.14-3.13a6.054,6.054,0,0,0-.11-1.151Z"
                    fill="#455b64"
                />
                <path
                    id="Path_74"
                    data-name="Path 74"
                    d="M382.08,175.62s31.1-2.77,33.93-3.36,11.52-.22,11.52-.22l-10.16,28.41-42-4.85c-7.27-2.39-13.16-16-13.16-16l-13.79-26.2L363,152.15Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_75"
                    data-name="Path 75"
                    d="M460.18,173.24c.54.18,16.69,6,21.39,9.11,3.31,2.17,3.62,7.73,2,11.35l-8,18.07-4.49,22.35,14.54,35,1.47,5.76-70.27,5-3.08-7.28,3.66-33.06V197.93L427.53,172l17.41.22Z"
                    fill="#707272"
                />
                <g id="Group_6" data-name="Group 6" opacity="0.3">
                    <path
                        id="Path_76"
                        data-name="Path 76"
                        d="M421.94,254.8a5.53,5.53,0,0,1,2.81-1.44A280.539,280.539,0,0,1,463.43,245c3-.43,6.2-.79,9.1.2s6.22,3.75,6,6.81l.42,1a31.38,31.38,0,0,1-17.82,4.25c-3.71-.16-7.77-.89-10.88,1.14-2.11,1.37-3.31,3.75-5.12,5.5a11.17,11.17,0,0,1-9,3,11.47,11.47,0,0,1-8.08-5.09c-1-1.53-1.86-3.48-3.65-3.82a6.837,6.837,0,0,1-2.24-.38A2,2,0,0,1,421.94,254.8Z"
                    />
                </g>
                <path
                    id="Path_77"
                    data-name="Path 77"
                    d="M480.93,181.91s2.72,1.14,5.35,5.06,11.37,29.7,11.37,29.7l-22.31,9.26-5.54-11.85Z"
                    fill="#707272"
                />
                <g id="Group_7" data-name="Group 7" opacity="0.5">
                    <path
                        id="Path_78"
                        data-name="Path 78"
                        d="M475.47,200.85a3.81,3.81,0,0,0-.24.86c-.13.56-.29,1.38-.47,2.39-.36,2-.76,4.82-1.05,7.94s-.41,6-.43,8v2.43a2.64,2.64,0,0,0,.09.89,26.665,26.665,0,0,0,.24-3.31c.11-2,.28-4.86.57-8s.64-5.91.9-7.94A23.575,23.575,0,0,0,475.47,200.85Z"
                    />
                </g>
                <g id="Group_8" data-name="Group 8" opacity="0.5">
                    <path
                        id="Path_79"
                        data-name="Path 79"
                        d="M439.2,215.62a3.251,3.251,0,0,0,0,.92,13.844,13.844,0,0,0,.45,2.45,16.64,16.64,0,0,0,10.94,11.49,14.811,14.811,0,0,0,2.43.57,2.75,2.75,0,0,0,.91,0c0-.09-1.28-.24-3.22-.95A17.45,17.45,0,0,1,440,218.89C439.38,216.91,439.29,215.61,439.2,215.62Z"
                    />
                </g>
                <path
                    id="Path_80"
                    data-name="Path 80"
                    d="M419.48,172c-4,0-19.63,2-19.63,2l-1.68,25.42,19.2,2.33L430.56,172S423.42,171.93,419.48,172Z"
                    fill="#707272"
                />
                <path
                    id="Path_81"
                    data-name="Path 81"
                    d="M410.18,134.12a1.05,1.05,0,0,1,1.06-.87,1,1,0,0,1-.3-1.09,1.06,1.06,0,0,1,1.43-.57,2,2,0,0,1,1.43-3c-1.07-1.23.36-3.54,1.95-3.13a1.38,1.38,0,0,1,1.53-2.27,1.67,1.67,0,0,1,2.17-2,1.81,1.81,0,0,1,2.29-2,1.25,1.25,0,0,1,2.29-1,1.58,1.58,0,0,1,2.78-1.44,1.46,1.46,0,0,1,2.64-1.19,2.18,2.18,0,0,1,3.89-1.5,1.63,1.63,0,0,1,1.63-1.51,4.75,4.75,0,0,1,2.33.77,1.64,1.64,0,0,1,1.79-.86,4.94,4.94,0,0,1,1.92.95,2.38,2.38,0,0,1,.59-1.16l1.28.56a2.14,2.14,0,0,1,1.74-3.86c-.77-1,.12-2.39,1-3.32l.75-.82a2.81,2.81,0,0,1,.77-.65,1.39,1.39,0,0,1,1.76.59,1.42,1.42,0,0,1,2.68-.87,2.31,2.31,0,0,1,3.8,0c0-.69,1-.85,1.64-.52s1.12.92,1.81,1A7.749,7.749,0,0,0,460,104a2,2,0,0,1,2.16,1.67,3.05,3.05,0,0,1,3.62,1.29c1.7-.11,3.27.84,4.71,1.75.69.43,1.45,1.34.87,1.91a2.35,2.35,0,0,1,2.65,2.4,2,2,0,0,1,2.24,2.67,1.34,1.34,0,0,1,1.42,1.93,1.52,1.52,0,0,1,1.69,2c.8-.24,1.43.9,1.09,1.66a3.26,3.26,0,0,1-1.94,1.46,2.41,2.41,0,0,1,1.75.34c.47.38.53,1.27,0,1.53a2.35,2.35,0,0,1,2.32,2.72,1.34,1.34,0,0,1,1.05,2.21,1.88,1.88,0,0,1,.12,3.2,3.46,3.46,0,0,1,.73,4.93,1.4,1.4,0,0,1-.29,2.48,2.65,2.65,0,0,1-1.9,3.87,1.54,1.54,0,0,1,.85,2.91.994.994,0,0,1,0,.17,8.765,8.765,0,0,1-.33.94.221.221,0,0,1,0,.08,2.219,2.219,0,0,1,.13.81,1.109,1.109,0,0,1,0,.17,5,5,0,0,1,.25,1c.13,1.57-1.59,2.72-2.71,4a6.79,6.79,0,0,0-1.38,2.37c-.33,1-.84,2.4-2,2.26.82.86,0,2.47-1.24,2.59.61.15.52,1,0,1.39a10.851,10.851,0,0,1-1.73.78,19.614,19.614,0,0,0-1.65,1.23,1.79,1.79,0,0,1-2,.16,1.141,1.141,0,0,1-.1.19h0a.72.72,0,0,1-.12,1.1,2,2,0,0,1-1.23.27h-1.42a12.32,12.32,0,0,1-5.91.75,2.65,2.65,0,0,1-3.1.43,4.51,4.51,0,0,1-4,.38,3.49,3.49,0,0,1-2.23-2.85l-1.71-.29-6.21,2.05a6.117,6.117,0,0,1-4,.36,2.85,2.85,0,0,1-3.29.21,4.13,4.13,0,0,1-4.4.25A2.73,2.73,0,0,1,430.3,169a12.694,12.694,0,0,0-1.36-.19c-.9,0-1.91.63-2.6.14-.41-.28-.45-.83-.78-1.19a3.57,3.57,0,0,0-1.71-.65c-.6-.16-1.7-3.08-1.47-3.61-1.44.08-2.48-2.4-3.12-4.51a2.7,2.7,0,0,1-.91-3.38,4.9,4.9,0,0,1-2.85-4.14c-.59.05-1-.55-1.19-1.13a6.709,6.709,0,0,0-.45-1.72c-.28-.48-.8-.81-1-1.33a2.24,2.24,0,0,1,0-1.12c.26-1.37.52-2.74.79-4.11a1.4,1.4,0,0,1-.76-2.19l-1.45-.93a1.36,1.36,0,0,1,.71-.88l-1.29-.73a1.49,1.49,0,0,0,.43-1.46l2.49-.66-2.63.69A2.15,2.15,0,0,1,410.18,134.12Z"
                    fill="#515251"
                />
                <path
                    id="Path_82"
                    data-name="Path 82"
                    d="M460.75,126.9l-17.17-3.71c-6.34-.84-13.38,5.36-13.94,11.74-.63,7.08-1.11,15.74-.41,21.06,1.42,10.68,9.54,12.24,9.54,12.24l-.12,4.36a11.58,11.58,0,0,0,11.05,11.89h0a11.57,11.57,0,0,0,12.07-11L464,131.06a4.07,4.07,0,0,0-3.25-4.16Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_83"
                    data-name="Path 83"
                    d="M431.14,142.26a1.37,1.37,0,0,0,1.28,1.41,1.31,1.31,0,0,0,1.44-1.2,1.36,1.36,0,0,0-1.28-1.41,1.31,1.31,0,0,0-1.44,1.2Z"
                    fill="#707272"
                />
                <path
                    id="Path_84"
                    data-name="Path 84"
                    d="M431,139.82c.12.23,1.31-.42,2.75-.14s2.34,1.28,2.54,1.11,0-.45-.4-.91a3.44,3.44,0,0,0-4.22-.78C431.11,139.4,430.89,139.72,431,139.82Z"
                    fill="#707272"
                />
                <path
                    id="Path_85"
                    data-name="Path 85"
                    d="M445.52,143.17a1.36,1.36,0,0,0,1.28,1.41,1.29,1.29,0,0,0,1.43-1.19A1.36,1.36,0,0,0,447,142a1.3,1.3,0,0,0-1.48,1.17Z"
                    fill="#707272"
                />
                <path
                    id="Path_86"
                    data-name="Path 86"
                    d="M445.18,140.89c.18.21,1.39-.64,3.06-.58s2.87.94,3.06.73-.1-.46-.62-.88a4.3,4.3,0,0,0-2.44-.84,4,4,0,0,0-2.44.72C445.27,140.43,445.09,140.8,445.18,140.89Z"
                    fill="#707272"
                />
                <path
                    id="Path_87"
                    data-name="Path 87"
                    d="M440.23,150.88a10.149,10.149,0,0,0-2.38-.49c-.37,0-.72-.13-.78-.39a1.93,1.93,0,0,1,.28-1.1c.37-.9.77-1.84,1.18-2.83,1.64-4,2.84-7.34,2.68-7.41s-1.63,3.15-3.27,7.18c-.4,1-.77,1.93-1.13,2.84a2.17,2.17,0,0,0-.24,1.47,1,1,0,0,0,.61.56,2.7,2.7,0,0,0,.63.11,10.089,10.089,0,0,0,2.42.06Z"
                    fill="#707272"
                />
                <g id="Group_9" data-name="Group 9" opacity="0.5">
                    <path
                        id="Path_88"
                        data-name="Path 88"
                        d="M438.77,168.23a27.12,27.12,0,0,0,14.35-3.44s-3.88,7.27-14.5,6Z"
                        fill="#707272"
                    />
                </g>
                <path
                    id="Path_89"
                    data-name="Path 89"
                    d="M444.58,137.58c.18.38,1.62,0,3.36.09s3.17.36,3.36,0c.08-.18-.2-.53-.79-.86a5.65,5.65,0,0,0-2.56-.63,5.51,5.51,0,0,0-2.56.57C444.78,137.05,444.5,137.39,444.58,137.58Z"
                    fill="#263238"
                />
                <path
                    id="Path_90"
                    data-name="Path 90"
                    d="M431.05,136c.24.37,1.39.19,2.72.37s2.42.58,2.72.27c.14-.15,0-.51-.43-.89a4.35,4.35,0,0,0-4.39-.52C431.16,135.48,431,135.79,431.05,136Z"
                    fill="#263238"
                />
                <path
                    id="Path_91"
                    data-name="Path 91"
                    d="M462.45,145.74c.16-.07,6.36-1.87,6.15,4.46s-6.52,4.8-6.53,4.62S462.45,145.74,462.45,145.74Z"
                    fill="#e4e3e3"
                />
                <g id="Group_10" data-name="Group 10" opacity="0.7">
                    <path
                        id="Path_92"
                        data-name="Path 92"
                        d="M464.08,152.49a2.251,2.251,0,0,0,.29.17,1.12,1.12,0,0,0,.83.05,2.76,2.76,0,0,0,1.34-2.41,3.68,3.68,0,0,0-.25-1.58,1.3,1.3,0,0,0-.8-.88.56.56,0,0,0-.66.28c-.1.18-.06.3-.09.31s-.14-.11-.08-.37a.66.66,0,0,1,.27-.38.83.83,0,0,1,.61-.15,1.56,1.56,0,0,1,1.12,1,3.8,3.8,0,0,1,.32,1.78,2.86,2.86,0,0,1-1.7,2.68,1.2,1.2,0,0,1-1-.2C464.09,152.64,464.06,152.5,464.08,152.49Z"
                        fill="#707272"
                    />
                </g>
                <path
                    id="Path_93"
                    data-name="Path 93"
                    d="M471.89,160.28c-3.09,1-2-13.85-4.66-15.76s-3.43,5.44-7,2.78c-2.3-1.72-.7-2.8-2-5.35-1.72-3.39-6.81-3.88-8.55-7.25-1-2-.61-4.45-1.72-6.36s-3.16-2.64-5.18-3.11-4.16-.7-5.94-1.77-3.07-3.33-2.24-5.23a109.7,109.7,0,0,1,25.906,3.1c1.994.468,3.994,1.078,5.344,2.618s1.6,3.91,1.76,6q1.13,15.6,2.27,31.19"
                    fill="#515251"
                />
                <path
                    id="Path_94"
                    data-name="Path 94"
                    d="M447.89,103a2.582,2.582,0,0,0-.21-.18,1.24,1.24,0,0,0-.72-.25,1.44,1.44,0,0,0-1.09.44,2.28,2.28,0,0,0-.58,1.47v.14l-.14-.06a2.27,2.27,0,0,0-2.31.33,2.22,2.22,0,0,0-.59,2.59l.32.72-.53-.58a1.44,1.44,0,0,0-1.63-.23,1.56,1.56,0,0,0-.87,1.78,2.139,2.139,0,0,0,.41,1,1.17,1.17,0,0,0,.75.54.29.29,0,0,0,.27-.2c0-.09,0-.18-.16-.2a.6.6,0,0,0-.61.42,2.28,2.28,0,0,0,.11,1.59,6.23,6.23,0,0,0,1.24,2.08c.39.43.65.63.63.65l-.2-.13a5.222,5.222,0,0,1-.5-.45,5.78,5.78,0,0,1-1.35-2.09,2.48,2.48,0,0,1-.13-1.74.83.83,0,0,1,.85-.56.43.43,0,0,1,.28.16.38.38,0,0,1,.07.34.53.53,0,0,1-.5.37.94.94,0,0,1-.55-.22,2.221,2.221,0,0,1-.4-.41,2.32,2.32,0,0,1-.46-1,2.07,2.07,0,0,1,.12-1.2,1.76,1.76,0,0,1,.89-.87,1.68,1.68,0,0,1,1.93.3l-.21.14a2.43,2.43,0,0,1,3.22-3.21l-.14.09a2.32,2.32,0,0,1,.66-1.57,1.52,1.52,0,0,1,1.2-.44,1.075,1.075,0,0,1,.9.48Z"
                    fill="#707272"
                />
                <path
                    id="Path_95"
                    data-name="Path 95"
                    d="M425.49,116l-.07-.14a.84.84,0,0,1,0-.45,1.19,1.19,0,0,1,.4-.61,1,1,0,0,1,.95-.21l-.1.08a1.25,1.25,0,0,1,.36-1,1.33,1.33,0,0,1,1.2-.4l-.13.08a2.92,2.92,0,0,1,.47-1.08,1.2,1.2,0,0,1,.56-.37.85.85,0,0,1,.71.08l-.19.09a1.56,1.56,0,0,1,3-.36l.43,1-.65-.91a1.06,1.06,0,0,1-.19-.45,1.41,1.41,0,0,1,.57-1.38,1.64,1.64,0,0,1,1.41-.17,2,2,0,0,1,1.07.81,3,3,0,0,1,.45,1.17h-.23a1.1,1.1,0,0,1,.9-.93,1.76,1.76,0,0,1,1.15.2,4.1,4.1,0,0,1,1.38,1.22,2,2,0,0,1,.39,1.13,1.112,1.112,0,0,1,0,.31.388.388,0,0,1,0,.1s0-.14,0-.41a2.07,2.07,0,0,0-.43-1,4.05,4.05,0,0,0-1.36-1.13,1.48,1.48,0,0,0-1-.16.88.88,0,0,0-.72.74l-.07,1-.16-1a2.13,2.13,0,0,0-1.36-1.78,1.41,1.41,0,0,0-1.2.15,1.17,1.17,0,0,0-.46,1.11,1,1,0,0,0,.15.35l-.23.12A1.34,1.34,0,0,0,431,111a1.36,1.36,0,0,0-1.09,1.09v.19l-.16-.11a.78.78,0,0,0-.95.24,2.57,2.57,0,0,0-.45,1v.1h-.09a1.16,1.16,0,0,0-1.36,1.19v.13h-.12a.89.89,0,0,0-.83.17,1.15,1.15,0,0,0-.39.53A1,1,0,0,0,425.49,116Z"
                    fill="#707272"
                />
                <path
                    id="Path_96"
                    data-name="Path 96"
                    d="M468.49,133.28a2.39,2.39,0,0,0,.21-1,2.62,2.62,0,0,0-.34-1.19,2.19,2.19,0,0,0-1.27-1h-.08v-.08a1.23,1.23,0,0,0-.33-1.25,1.08,1.08,0,0,0-.68-.29,1.3,1.3,0,0,1-.85-.28,1.93,1.93,0,0,1-.37-.86,1.52,1.52,0,0,0-.39-.79,1.54,1.54,0,0,0-1.72-.37l-.45.21.32-.38a1.4,1.4,0,0,0,0-1.74,1.38,1.38,0,0,0-1.82-.18l-.3.23.11-.36a2.15,2.15,0,0,0-3.62-2.08l-.26.27v-.37a3.31,3.31,0,0,0-.45-1.94,3.48,3.48,0,0,0-1.32-1.29,3,3,0,0,0-1.76-.34,3.41,3.41,0,0,0-2.74,1.92l-.13.3-.1-.32a1.94,1.94,0,0,0-1.14-1.17,2.48,2.48,0,0,0-1.61-.1,4.35,4.35,0,0,0-2.34,1.92l-.06.1-.09-.08a4.48,4.48,0,0,0-3.5-1,4.33,4.33,0,0,0-2.5,1.28,4.649,4.649,0,0,0-1,1.53c-.15.39-.2.62-.21.61a2.459,2.459,0,0,1,.15-.63,4.48,4.48,0,0,1,1-1.59,4.42,4.42,0,0,1,2.57-1.37,4.68,4.68,0,0,1,3.65,1h-.15a4.53,4.53,0,0,1,2.45-2,2.74,2.74,0,0,1,1.76.1,2.19,2.19,0,0,1,1.29,1.32h-.24a3.69,3.69,0,0,1,2.95-2.08,3.25,3.25,0,0,1,1.9.38,3.71,3.71,0,0,1,1.43,1.38,3.6,3.6,0,0,1,.48,2.1l-.22-.11a2.4,2.4,0,0,1,4,2.33l-.19-.13a1.57,1.57,0,0,1,2.17,2.25l-.13-.17a1.75,1.75,0,0,1,2,.43c.52.51.38,1.28.75,1.66a1.16,1.16,0,0,0,.73.24,1.24,1.24,0,0,1,.77.34,1.34,1.34,0,0,1,.35,1.42l-.05-.09a2.26,2.26,0,0,1,1.33,1.1,2.561,2.561,0,0,1,.33,1.24,2,2,0,0,1-.16.78.84.84,0,0,1-.13.19Z"
                    fill="#707272"
                />
                <path
                    id="Path_97"
                    data-name="Path 97"
                    d="M418,134.48a2.8,2.8,0,0,1-.23-.38,8.359,8.359,0,0,1-.5-1.13,3.3,3.3,0,0,1-.14-1.94,2.51,2.51,0,0,1,.62-1.06,1.72,1.72,0,0,1,1.27-.53l-.11.13a2.19,2.19,0,0,1,.7-1.94,2.23,2.23,0,0,1,2.19-.6l-.16.14a2.82,2.82,0,0,1,.57-2.18,2.72,2.72,0,0,1,2.16-1,2.77,2.77,0,0,1,1,.17c.29.09.6.17.79,0s.25-.46.43-.74a2.631,2.631,0,0,1,.66-.67,2.57,2.57,0,0,1,3.22.27h-.2a7.072,7.072,0,0,1,.52-1.65,2.31,2.31,0,0,1,1.1-1.14,2.08,2.08,0,0,1,1.39,0,5.62,5.62,0,0,1,1.1.41,5.9,5.9,0,0,1,1.35.93l.3.3.09.12a7.47,7.47,0,0,0-1.8-1.23,6.179,6.179,0,0,0-1.08-.37,1.86,1.86,0,0,0-1.27,0,2,2,0,0,0-1,1,7,7,0,0,0-.48,1.61v.22l-.16-.17a2.34,2.34,0,0,0-2.91-.21,2.07,2.07,0,0,0-.58.6,3.537,3.537,0,0,0-.19.39.89.89,0,0,1-.31.43.78.78,0,0,1-.53.11,2.4,2.4,0,0,1-.48-.11,2.74,2.74,0,0,0-.89-.16,2.49,2.49,0,0,0-2,.92,2.54,2.54,0,0,0-.52,2v.2l-.19-.06a2.137,2.137,0,0,0-2.65,2.26v.13H419a1.54,1.54,0,0,0-1.13.45,2.39,2.39,0,0,0-.59,1,3.32,3.32,0,0,0,.09,1.85A8.174,8.174,0,0,0,418,134.48Z"
                    fill="#707272"
                />
                <path
                    id="Path_98"
                    data-name="Path 98"
                    d="M478.83,123.37a3.41,3.41,0,0,0-.22-1,3,3,0,0,0-.72-1,2.55,2.55,0,0,0-1.5-.67h-.09v-.08a1.94,1.94,0,0,0,0-1.55,2,2,0,0,0-1.28-1.23h-.08v-.09a1.78,1.78,0,0,0-.18-1.43,1.74,1.74,0,0,0-1.26-.9,1.55,1.55,0,0,1-.91-.26c-.27-.3-.16-.68-.27-.92a1.07,1.07,0,0,0-1.46-.54l-.12.08v-.15a2.48,2.48,0,0,0-3.23-1.55h-.12l-.05-.12a2.15,2.15,0,0,0-3.28-.81l-.12.11-.07-.15a2.16,2.16,0,0,0-3.6,0l-.13.24-.1-.25a1.52,1.52,0,0,0-2.92.62v.35l-.23-.26a2.52,2.52,0,0,0-4,.63l-.08.19-.14-.16a2.56,2.56,0,0,0-4.51,1.34v.17l-.15-.08a3.37,3.37,0,0,0-4.93,3.13v.11H443a4.967,4.967,0,0,0-5.28,3.51,5.31,5.31,0,0,0-.22,1.86,4.129,4.129,0,0,0,.07.65,3.555,3.555,0,0,1-.12-.65,5,5,0,0,1,.17-1.89,4.88,4.88,0,0,1,1.63-2.51,5.18,5.18,0,0,1,3.77-1.16l-.1.1a3.57,3.57,0,0,1,5.23-3.35l-.17.09a2.81,2.81,0,0,1,4.94-1.47h-.22a2.79,2.79,0,0,1,4.46-.7l-.23.08A1.84,1.84,0,0,1,458,110a1.82,1.82,0,0,1,2.29.95h-.24a2.435,2.435,0,0,1,4.08.03h-.2a2.4,2.4,0,0,1,3.68.92l-.16-.07a2.71,2.71,0,0,1,3.55,1.72l-.17-.07a1.29,1.29,0,0,1,1.77.66c.11.34,0,.67.22.84a1.539,1.539,0,0,0,.78.21,2,2,0,0,1,1.41,1,1.92,1.92,0,0,1,.17,1.58l-.06-.11a2.22,2.22,0,0,1,1.38,1.33,2.11,2.11,0,0,1,0,1.66l-.05-.09a2.62,2.62,0,0,1,1.55.72,3,3,0,0,1,.72,1,2.579,2.579,0,0,1,.17.76C478.84,123.28,478.83,123.37,478.83,123.37Z"
                    fill="#707272"
                />
                <path
                    id="Path_99"
                    data-name="Path 99"
                    d="M469.12,152.39a.5.5,0,0,1,.21.07,3.669,3.669,0,0,1,.53.32,3.87,3.87,0,0,1,1.39,1.81,5,5,0,0,1,0,3.38,3.88,3.88,0,0,1-1.2,1.63,4.43,4.43,0,0,1-1.95,1,4.34,4.34,0,0,1-2.16-.27,3.86,3.86,0,0,1-1.66-1.17,4.26,4.26,0,0,1-.89-3.24,3.92,3.92,0,0,1,.9-2.1,2,2,0,0,1,.48-.39c.13-.07.2-.1.2-.09a4.24,4.24,0,0,0-.61.55,4,4,0,0,0-.79,2,4.07,4.07,0,0,0,.9,3.06,3.53,3.53,0,0,0,1.56,1.09,4.08,4.08,0,0,0,2,.25,4.18,4.18,0,0,0,1.84-.9,3.71,3.71,0,0,0,1.14-1.53,4.89,4.89,0,0,0,0-3.23,4,4,0,0,0-1.27-1.79A6.7,6.7,0,0,0,469.12,152.39Z"
                    fill="#e0e0e0"
                />
                <g id="Group_11" data-name="Group 11" opacity="0.3">
                    <path
                        id="Path_100"
                        data-name="Path 100"
                        d="M444.19,152.69a1.83,1.83,0,0,0-1.16-.54,2.24,2.24,0,0,0-1.79.53,1.6,1.6,0,0,0-.41,1.76v-.17a1.79,1.79,0,0,0,1.07,1.4,1.89,1.89,0,0,0,1.77-.18,2,2,0,0,0,.89-1.55,1.67,1.67,0,0,0-.37-1.25Z"
                        fill="#707272"
                    />
                </g>
                <path
                    id="Path_101"
                    data-name="Path 101"
                    d="M464.17,144.58a2.19,2.19,0,0,1-1.59,1.91c.41,0,.5.67.22,1a1.44,1.44,0,0,1-1.15.28,6.31,6.31,0,0,1-4.8-3,1.84,1.84,0,0,1-.79-2.78,1.64,1.64,0,0,1-1-2,1.32,1.32,0,0,1-1.54-1.42,16.59,16.59,0,0,1-5.35-4.05,1.7,1.7,0,0,1,.14-2.26,1.28,1.28,0,0,1-.39-2.12,1.23,1.23,0,0,1-.87-1.53c-.73-.07-4.4-.37-4.39-1.11-2-.62-3-1.65-3.07-2.23s-1.15-.43-1.22-1c-.09-.75.89-1.11,1.64-1.14a13.63,13.63,0,0,1,6.5,1.35,27.34,27.34,0,0,1,6.18,4.59l2.62,2.36c.66.6,1.39,1.41,1.13,2.26.64-.32,1.4.24,1.7.88s.35,1.39.7,2A8.851,8.851,0,0,0,460,138a2,2,0,0,1,.57,1.73,2.44,2.44,0,0,1,2.55,1.62c.57-.36,1.37.21,1.47.88a3.06,3.06,0,0,1-.57,1.91"
                    fill="#515251"
                />
                <path
                    id="Path_102"
                    data-name="Path 102"
                    d="M443.07,142.63a8.532,8.532,0,0,1,0-1.41,5.77,5.77,0,0,1,1.67-3.36,5.66,5.66,0,0,1,2.22-1.35,5.59,5.59,0,0,1,3-.14,5.15,5.15,0,0,1,1.51.57,5.231,5.231,0,0,1,1.33,1,5.62,5.62,0,0,1,1.53,3.15,5.691,5.691,0,0,1-.64,3.44,5.4,5.4,0,0,1-1,1.34,5.209,5.209,0,0,1-1.31.95,5.62,5.62,0,0,1-5.4-.07,5.8,5.8,0,0,1-2.49-2.8,12.781,12.781,0,0,1-.41-1.35,2,2,0,0,0,.05.37,2.21,2.21,0,0,0,.09.43,3.42,3.42,0,0,0,.18.58,5.75,5.75,0,0,0,2.5,2.92,5.63,5.63,0,0,0,2.57.77,5.82,5.82,0,0,0,3-.64,5.891,5.891,0,0,0,1.37-1,5.44,5.44,0,0,0,1.06-1.4,5.8,5.8,0,0,0-.92-6.87,5.32,5.32,0,0,0-1.4-1.07,5.5,5.5,0,0,0-1.58-.59,6,6,0,0,0-3.08.17,5.78,5.78,0,0,0-2.28,1.43,5.67,5.67,0,0,0-1.63,3.47,3.311,3.311,0,0,0,0,.61,2.8,2.8,0,0,0,0,.45,2.519,2.519,0,0,0,.06.4Z"
                    fill="#455b64"
                />
                <path
                    id="Path_103"
                    data-name="Path 103"
                    d="M426.76,141.83a8.532,8.532,0,0,1,0-1.41,5.74,5.74,0,0,1,1.67-3.36,5.64,5.64,0,0,1,5.19-1.49,5.15,5.15,0,0,1,1.51.57,5.271,5.271,0,0,1,1.34,1,5.62,5.62,0,0,1,.88,6.59,5.4,5.4,0,0,1-1,1.34,5,5,0,0,1-1.31,1,5.66,5.66,0,0,1-2.9.65,5.72,5.72,0,0,1-5-3.52,12.774,12.774,0,0,1-.41-1.35,1.994,1.994,0,0,0,.05.36,2.29,2.29,0,0,0,.09.44,3.418,3.418,0,0,0,.18.58,5.777,5.777,0,0,0,8.07,3.04,5.57,5.57,0,0,0,1.37-1,5.439,5.439,0,0,0,1.06-1.4,5.8,5.8,0,0,0-.92-6.87,5.32,5.32,0,0,0-1.4-1.07,5.45,5.45,0,0,0-1.57-.59,6,6,0,0,0-3.09.17,5.85,5.85,0,0,0-2.28,1.43,5.73,5.73,0,0,0-1.63,3.47,4.506,4.506,0,0,0,0,.61,2.681,2.681,0,0,0,0,.44A2.541,2.541,0,0,1,426.76,141.83Z"
                    fill="#455b64"
                />
                <path
                    id="Path_104"
                    data-name="Path 104"
                    d="M427.26,137.44a6,6,0,0,1,5.07-2.65,9,9,0,0,1,6,3,7.79,7.79,0,0,1,5.14.39,7,7,0,0,1,5.65-2.72c3.25,0,5.65,3.24,5.65,3.24l2.56.38-.26,2.28-2.88-.35s-1.19-4.18-4.74-4.41c-4.77-.31-5.58,3.21-5.58,3.21l-1.13-.13.37-.67s-2.66-1-4.55-.18v.82h-.81a5.67,5.67,0,0,0-5.44-3.84,5.36,5.36,0,0,0-5.39,4.69l-1.9-.21.07-2.26Z"
                    fill="#455b64"
                />
                <path
                    id="Path_105"
                    data-name="Path 105"
                    d="M449.06,146.86a2.32,2.32,0,0,0,1.05,0,5,5,0,0,0,3.7-3.21,2.7,2.7,0,0,0,.2-1s-.12.38-.36,1a5.54,5.54,0,0,1-1.43,2,5.681,5.681,0,0,1-2.15,1.13A4.513,4.513,0,0,0,449.06,146.86Z"
                    fill="#fff"
                />
                <path
                    id="Path_106"
                    data-name="Path 106"
                    d="M433.63,145.73a1.86,1.86,0,0,0,.83-.13,4.15,4.15,0,0,0,1.72-1.06,4.24,4.24,0,0,0,1-1.74,1.81,1.81,0,0,0,.11-.83,6.821,6.821,0,0,0-.28.78,4.8,4.8,0,0,1-1.05,1.62,4.9,4.9,0,0,1-1.6,1.07,6.2,6.2,0,0,0-.73.29Z"
                    fill="#fff"
                />
                <path
                    id="Path_107"
                    data-name="Path 107"
                    d="M447.71,242.12l31.14-10-2-7,18.23-7.3c2.58,7.28,4.49,12,5.2,17.48,0,.34.07.67.1,1,.47,7.53-5.23,14.06-12.69,15.18L450.12,254Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_108"
                    data-name="Path 108"
                    d="M444.91,151.14c-.24,0-.43,1.54-1.93,2.5s-3.16.59-3.2.81.34.35,1.05.46a4.07,4.07,0,0,0,2.66-.58,3.47,3.47,0,0,0,1.52-2.12C445.15,151.56,445,151.14,444.91,151.14Z"
                    fill="#263238"
                />
                <rect
                    id="Rectangle_5"
                    data-name="Rectangle 5"
                    width="110.7"
                    height="138.47"
                    transform="translate(286.804 250.745) rotate(-76.74)"
                    fill="#fafbfb"
                />
                <path
                    id="Path_109"
                    data-name="Path 109"
                    d="M447,174.76l-.65-.13-1.9-.43-7.33-1.68-27.62-6.41-97.36-22.76.43-.27c-7.54,32.08-16.19,68.84-25.35,107.75h0l-.3-.48,134.77,31.83-.4.25C429,250,435.4,223.12,439.87,204.32c2.25-9.4,4-16.77,5.23-21.82q.92-3.76,1.4-5.76c.32-1.3.5-2,.5-2s-.12.65-.41,1.94l-1.31,5.71c-1.17,5-2.87,12.4-5.05,21.79-4.4,18.87-10.7,45.85-18.29,78.39l-.08.33-.33-.08-134.79-31.7-.39-.09.09-.39h0c9.19-38.9,17.86-75.66,25.44-107.73l.08-.35.35.08,97.5,23.16,27.49,6.58,7.25,1.75,1.85.46Z"
                    fill="#515251"
                />
                <rect
                    id="Rectangle_6"
                    data-name="Rectangle 6"
                    width="96.77"
                    height="128.74"
                    transform="translate(293.053 245.061) rotate(-76.74)"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_110"
                    data-name="Path 110"
                    d="M293.06,245.06l57.56-48.23,18.48,43.02,23-15.25,26.27,50Z"
                    fill="#455b64"
                />
                <path
                    id="Path_111"
                    data-name="Path 111"
                    d="M390.93,198.76a10.14,10.14,0,1,1-7.54-12.19,10.14,10.14,0,0,1,7.54,12.19Z"
                    fill="#455b64"
                />
                <path
                    id="Path_112"
                    data-name="Path 112"
                    d="M293.06,245.06l57.56-48.23,18.48,43.02,23-15.25,26.27,50Z"
                    fill="#707272"
                />
                <path
                    id="Path_113"
                    data-name="Path 113"
                    d="M390.93,198.76a10.14,10.14,0,1,1-7.54-12.19,10.14,10.14,0,0,1,7.54,12.19Z"
                    fill="#707272"
                />
                <path
                    id="Path_114"
                    data-name="Path 114"
                    d="M368.56,157a6.07,6.07,0,0,0,.81-2.62,2.28,2.28,0,0,0-1.36-2.22,3.2,3.2,0,0,0-2.42.46,4.51,4.51,0,0,1-2.39.75,16.246,16.246,0,0,1-1.8-.55c-.62-.13-1.41.08-1.56.69a1.08,1.08,0,0,0,.47,1.08,3.2,3.2,0,0,0,1.17.45l7.4,1.8"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_115"
                    data-name="Path 115"
                    d="M347.58,149.1s1.76,5.64,2.6,5.78a3.39,3.39,0,0,0,1.94-.65s-.32,5.27,3.1,5.93c0,0,.63,1.6,1.8,1.72s1.38-1.36,1.38-1.36,1.88,2.19,2.58-.24a61.722,61.722,0,0,0,1.2-8s-.7-2.5-1.76-2.26a3,3,0,0,0-1.56.87,7.12,7.12,0,0,0-2.15-2,1.47,1.47,0,0,0-1.87.42s-1.59-2.44-2.56-1.73-.51,1.39-.51,1.39-2.06-1.58-2.95-1.17a2.65,2.65,0,0,0-1.24,1.3Z"
                    fill="#e4e3e3"
                />
                <g id="Group_12" data-name="Group 12" opacity="0.3">
                    <path
                        id="Path_116"
                        data-name="Path 116"
                        d="M358.4,160.52a25.218,25.218,0,0,0,.47-4.84,25.206,25.206,0,0,0,0-4.86,24.707,24.707,0,0,0-.48,4.84A23.757,23.757,0,0,0,358.4,160.52Z"
                        fill="#707272"
                    />
                </g>
                <g id="Group_13" data-name="Group 13" opacity="0.3">
                    <path
                        id="Path_117"
                        data-name="Path 117"
                        d="M352.12,154.23a7.34,7.34,0,0,0,.19-2.63,5.38,5.38,0,0,0-.49-2.6,11.681,11.681,0,0,0,0,2.62,7.5,7.5,0,0,0,.3,2.61Z"
                        fill="#707272"
                    />
                </g>
                <g id="Group_14" data-name="Group 14" opacity="0.3">
                    <path
                        id="Path_118"
                        data-name="Path 118"
                        d="M355.26,160.2a29.777,29.777,0,0,0,0-5.45,31.621,31.621,0,0,0-.45-5.42,32,32,0,0,0,0,5.44A32,32,0,0,0,355.26,160.2Z"
                        fill="#707272"
                    />
                </g>
                <path
                    id="Path_119"
                    data-name="Path 119"
                    d="M447.71,242.12l-13.46-5.28L415,241.13a3.81,3.81,0,0,0,3.37,2.36c2.71.28,9.8-1.07,9.8-1.07l-11.56,4s2.2,2.33,4.8,1.75,9.08-1.91,9.08-1.91l-7.77,4.06a3.34,3.34,0,0,0,3.57,1.57c2.72-.29,7.59-2.51,7.59-2.51s10,4.58,13.1,4.58,4.45-.09,4.45-.09Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_120"
                    data-name="Path 120"
                    d="M433.22,237.07c.08,0-14.07-.71-14.07-.71a1.54,1.54,0,0,0,.7,1.83c1.13.88,5.5,1.4,5.5,1.4Z"
                    fill="#e4e3e3"
                />
                <g id="Group_15" data-name="Group 15" opacity="0.3">
                    <path
                        id="Path_121"
                        data-name="Path 121"
                        d="M433.46,236.79a13.048,13.048,0,0,1-2.66.83c-1.65.44-4,1-6.51,1.6s-4.87,1.09-6.55,1.43a13,13,0,0,1-2.74.43,13.049,13.049,0,0,1,2.66-.83c1.66-.43,4-1,6.5-1.59s4.86-1.1,6.55-1.44a14.741,14.741,0,0,1,2.75-.43Z"
                        fill="#707272"
                    />
                </g>
                <g id="Group_16" data-name="Group 16" opacity="0.3">
                    <path
                        id="Path_122"
                        data-name="Path 122"
                        d="M433.5,241.92c0,.17-1.36,0-3,.21s-2.85.67-2.92.52a4.72,4.72,0,0,1,2.85-1.09A4.77,4.77,0,0,1,433.5,241.92Z"
                        fill="#707272"
                    />
                </g>
                <g id="Group_17" data-name="Group 17" opacity="0.3">
                    <path
                        id="Path_123"
                        data-name="Path 123"
                        d="M435.14,246.37a9.79,9.79,0,0,0-2.28-.59,10,10,0,0,0-2.31.43c-.05-.06.13-.31.53-.56a3.39,3.39,0,0,1,1.8-.45,3.3,3.3,0,0,1,1.76.57C435,246.05,435.19,246.32,435.14,246.37Z"
                        fill="#707272"
                    />
                </g>
                <circle
                    id="Ellipse_1"
                    data-name="Ellipse 1"
                    cx="8.45"
                    cy="8.45"
                    r="8.45"
                    transform="translate(31.73 41.11)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <circle
                    id="Ellipse_2"
                    data-name="Ellipse 2"
                    cx="8.45"
                    cy="8.45"
                    r="8.45"
                    transform="translate(475.28 65.63)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <circle
                    id="Ellipse_3"
                    data-name="Ellipse 3"
                    cx="13.96"
                    cy="13.96"
                    r="13.96"
                    transform="translate(431.11 25.13)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <path
                    id="Path_124"
                    data-name="Path 124"
                    d="M110.28,193.63h-6.35v-6.34a.79.79,0,0,0-.79-.79h0a.81.81,0,0,0-.81.79v6.34H96a.82.82,0,0,0-.8.81.79.79,0,0,0,.8.79h6.34v6.36a.81.81,0,0,0,.81.79.79.79,0,0,0,.79-.79h0v-6.36h6.35a.79.79,0,0,0,.8-.79A.81.81,0,0,0,110.28,193.63Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <path
                    id="Path_125"
                    data-name="Path 125"
                    d="M316.71,119.36h-6.36V113a.79.79,0,0,0-.79-.79h0a.81.81,0,0,0-.81.79v6.35h-6.34a.8.8,0,0,0,0,1.6h6.34v6.35a.81.81,0,0,0,.81.79.79.79,0,0,0,.79-.79h0V121h6.36a.8.8,0,0,0,0-1.6Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <path
                    id="Path_126"
                    data-name="Path 126"
                    d="M27.47,249.06H18.09v-9.37a1.17,1.17,0,0,0-1.17-1.17h0a1.19,1.19,0,0,0-1.19,1.17v9.37H6.37a1.19,1.19,0,0,0-1.18,1.19,1.17,1.17,0,0,0,1.18,1.17h9.36v9.39A1.19,1.19,0,0,0,16.92,262a1.17,1.17,0,0,0,1.17-1.16h0v-9.39h9.38a1.18,1.18,0,0,0,0-2.36Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
            </g>
        </SVGIcon>
    );
}
